import React, {Component} from 'react';
import { Route, Switch } from 'react-router-dom'
import NotFound from './components/notFound';
import HomeContainer from './containers/HomeContainer';
import TablesContainer from './containers/TablesContainer';
import UserTableCuppings from './components/tables/UserTableCuppings';
import Profile from './components/users/Profile';
import ProfileShow from './components/users/ProfileShow' 
import TableShow from './components/tables/TableShow'
import CuppingScore from './components/cuppings/CuppingScore'
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import './App.css';
import { connect } from 'react-redux'
import Title from './components/Title'
import {fetchUser} from './actions/actions'

class App extends Component {

  componentDidMount() {
        const token = localStorage.getItem('jwt')
        // console.log('%c ***LOCAL TOKEN*** ', 'color: violet', token)
        if (token) {
          this.props.fetchUser(token)
         }  
        // window.scrollTo(0, 0);

    }

  
  generateContainerAndTitle = (Container, pageTitle) => {
    return (
      <>
      <Container /> 
      <Title title={pageTitle}/> 
      </>
    )
  }

  loggedUserRoutes = () => {
    if (this.props.isLoggedIn){
      return (
        <Switch>
          <Route exact path='/' component={ HomeContainer } />
          <Route path='/tables/:table_id' render={() =>  this.generateContainerAndTitle(TableShow, "Cupping Table - Catoro")} />
          <Route path='/profile/:profile_id' render={() =>  this.generateContainerAndTitle(ProfileShow, "Catador Profile - Catoro")} /> 
          <Route path='/score_cupping/:cupping_id' render={() =>  this.generateContainerAndTitle(CuppingScore, "Scoring Cupping - Catoro")} />
          <Route path='/cuppings/new' render={() => this.generateContainerAndTitle(TablesContainer, "New Cupping Table - Catoro")} /> 
          <Route path='/my_cuppings' render={() =>  this.generateContainerAndTitle(UserTableCuppings, "My Cuppings - Catoro")} />
          <Route path='/profile' render={() =>  this.generateContainerAndTitle(Profile, "My Profile - Catoro", true)} /> 
          <Route path='/error' render={() =>  this.generateContainerAndTitle(NotFound, "Error - Catoro")} />
          <Route render={() => this.generateContainerAndTitle(NotFound, "Wait a minute.. - Catoro")} /> 
        </Switch>
      )
    } else {
      return (
        <Switch>
          <Route exact path='/' component={ HomeContainer } />
          <Route path='/profile/:profile_id' render={() =>  this.generateContainerAndTitle(ProfileShow, "Catador Profile - Catoro")} /> 
          <Route path='/error' render={() =>  this.generateContainerAndTitle(NotFound, "Error - Catoro")} />            
          <Route render={() => this.generateContainerAndTitle(NotFound, "Wait a minute.. - Catoro")} /> 
        </Switch>
      )
    }
}
    
  render() {
    return (
      <React.Fragment>
          <NavBar /> 
            <br></br>
              {this.loggedUserRoutes()}
            <br></br>
          <Footer />  
      </React.Fragment>
    );
  }
};

const msp = state => {
  return {
    isLoggedIn: state.users.isLoggedIn,
  }
};

export default connect(msp, {
  fetchUser
})(App);

